import {
  Modal,
  Box,
  Typography,
  Link,
  Button,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdOutlineClose } from "react-icons/md";
import ReactMarkdown from "react-markdown";
import { useMutation, useQuery } from "react-query";
import remarkGfm from "remark-gfm";
import Footer from "../../components/Home/Footer";
import Header from "../../components/Layout/Header";
import fetcher from "../../src/dataProvider";
import { makeStyles } from "@mui/styles";
import { verifyEmail, verifyMobile, verifyUrl } from "../../util/validators";
import { STRAPI_API_URL } from "../../src/constant/appConstants";
import TagManager from "react-gtm-module";
import mixpanel from "mixpanel-browser";
import auth from "../../components/Layout/util/auth";
import eventBus from "../../util/eventBus";
import Slider from "react-slick";
import router from "next/router";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import Layout from "../../components/Layout/Layout";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#19132A",
    width: "100%",
    maxWidth: "576px",
    height: "121px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
    position: "fixed",
    top: "100px",
    left: "50%",
    transform: "translateX(-50%)",
    borderRadius: "24px",
    padding: "0 30px",
    zIndex: 1100,
    "@media(max-width:767px)": {
      width: "90%",
    },
  },
  btnContainer: {
    display: "flex",
    "@media(max-width:767px)": {
      flexDirection: "column",
    },
  },
  alertMessage: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    width: "100%",
  },
  content: {
    marginLeft: "10px !important",
    fontSize: "18px",
  },
  hiwImageSeparator: {
    width: "100%",
    height: "2.7px",
    position: "relative",
    display: "block",
    background: "#fff",
    borderRadius: "7px",
    boxShadow: "0px 0px 20px 1px #ff3780",
    margin: "20px 0 !important",
  },
  subTitle: {
    position: "relative",
    display: "block",
    color: "#fff",
    textAlign: "center !important",
    lineHeight: "30px",
    width: "100%",
    maxWidth: "530px !important",
    fontSize: "19px !important",
    fontWeight: "300 !important",
    margin: "0 auto 40px !important",
  },
  artistSliderBox: {
    position: "relative",
    display: "block",
    width: "100%",
  },
  artistBox: {
    position: "relative",
    display: "block",
    cursor: "pointer",
    width: "100%",
    maxWidth: "211px",
    background: "#3454FA",
    height: "236px",
    margin: "auto",
    borderRadius: "12px",
    overflow: "hidden",
    textAlign: "center",
    "& img:first-child": {
      position: "relative",
      display: "block",
      width: "100%",
      height: "236px",
      objectFit: "cover",
      opacity: "0.4",
    },
    "& img:last-child": {
      position: "absolute",
      width: "130px",
      height: "130px",
      objectFit: "cover",
      borderRadius: "50%",
      left: "50%",
      top: "50%",
      transform: "translate(-50%,-50%)",
    },
    "& + p": {
      position: "relative",
      display: "block",
      width: "100%",
      textAlign: "center",
      color: "#fff",
      marginTop: "23px",
      fontSize: "16px",
      fontWeight: "400",
    },
  },
}));

export async function getStaticProps() {
  let data;
  try {
    const res = await fetch(
      `${STRAPI_API_URL}/frontend-configs?filters[slug][$eq]=artistsubmission`
    );
    const data1 = await res.json();
    data = data1.data;
    return {
      props: {
        data,
      },
      revalidate: 10,
    };
  } catch (error) {
    // The  API most likely died
    console.error(error);
    return {
      props: {
        error: JSON.stringify(error),
      },
      revalidate: 10, // In seconds
    };
  }
}

export default function ArtistSubmission(props) {
  const classes = useStyles();

  const { userData } = useSelector((state) => state.user);

  let keyValue = new Map();
  props?.data?.forEach((item) => {
    keyValue.set(item.attributes.key, item.attributes.value);
  });
  const [expanded, setExpanded] = useState(false);
  const handlePanel = (panel) => {
    let panelDt = expanded === panel ? 0 : panel;
    setExpanded(panelDt);
  };

  const initialValues = {
    email: "",
    mobile: "",
    profileLink: "",
    songLink: "",
    username: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [successModal, setSuccessModal] = useState(false);
  const [artistQuestion, setArtistQuestion] = useState("");
  const [user, setUser] = useState(auth());
  const isMobile = useMediaQuery("(max-width:768px)");

  const r = auth();
  useEffect(() => {
    eventBus.on("userLoggedIn", () => {
      checkAuth();
    });
  });

  const checkAuth = () => {
    setUser(auth());
  };

  const handleChangeform = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const validateform = (values) => {
    setFormErrors({});
    const errors = {};
    if (values.username == "" || values.username == null) {
      errors.username = "Please enter your name!";
      setFormErrors(errors);
      return false;
    }
    if (!verifyEmail(values.email)) {
      errors.email = "Please enter valid email id";
      setFormErrors(errors);
      return false;
    }
    if (!verifyMobile(values.mobile)) {
      errors.mobile = "Please enter valid mobile no";
      setFormErrors(errors);
      return false;
    }

    if (!verifyUrl(values.profileLink)) {
      errors.profileLink = "Please enter valid profile link ";
      setFormErrors(errors);

      return false;
    }
    // if (!verifyUrl(values.songLink)) {
    //   errors.songLink = "Please enter valid song link ";
    //   setFormErrors(errors);
    //   return false;
    // }

    return true;
  };

  const submitArtistApplication = (formValues) => {
    let data = {
      name: formValues.username,
      email: formValues.email,
      mobile: formValues.mobile,
      profile_link: formValues.profileLink,
      song_link: formValues.songLink,
    };

    artistApplicationSubmition(data);
  };

  const { mutate: artistApplicationSubmition } = useMutation(
    (data) =>
      fetcher.post(`${STRAPI_API_URL}/artist-applications`, {
        data,
      }),

    {
      onSuccess: (res) => {
        console.log("artistApplicationSubmition", res);
        if (user.token) {
          const tagManagerArgs = {
            dataLayer: {
              event: "artistSubmit",
              userStatus: "loggedIn",
            },
          };
          TagManager.dataLayer(tagManagerArgs);
          mixpanel.track("Artist Page");
        } else {
          const tagManagerArgs = {
            dataLayer: {
              event: "artistSubmit",
              userStatus: "GuestUser",
            },
          };
          TagManager.dataLayer(tagManagerArgs);
          mixpanel.track("Artist Page");
        }
        setFormValues(initialValues);
        setSuccessModal(true);
      },
    }
  );

  const handleSubmit = (e) => {
    // if (user.token) {
    //   const tagManagerArgs = {
    //     dataLayer: {
    //        event: 'artistSubmit',
    //        userStatus: 'loggedIn',
    //     }
    //   }
    //   TagManager.dataLayer(tagManagerArgs);
    //   mixpanel.track("Artist Page");
    // } else {
    //   const tagManagerArgs = {
    //     dataLayer: {
    //        event: 'artistSubmit',
    //        userStatus: 'GuestUser',
    //     },
    //   }
    //   TagManager.dataLayer(tagManagerArgs);
    //   mixpanel.track("Artist Page");
    // }

    e.preventDefault();
    if (validateform(formValues)) {
      submitArtistApplication(formValues);
    } else {
      console.log(formValues);
      console.log("formErrors", formErrors);
    }
  };

  const { data: faqData } = useQuery(`${STRAPI_API_URL}/faq-questions`, () =>
    fetcher.get(`${STRAPI_API_URL}/faq-questions`, {
      params: {
        [`filters[faq_category][category_title][$eq]`]: "Artist FAQ",
        populate: "*",
        sort: ["sequence"],
      },
    })
  );

  useEffect(() => {
    if (faqData) {
      setArtistQuestion(faqData);
    }
  }, [faqData]);

  var artistsettings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    useTransform: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleJoinAsInArtist = () => {
    if (isEmpty(r.token)) {
      eventBus.dispatch("openLoginModal", {
        function_name: "uniqueCommunity",
      });
    } else {
      router.push("artist/createprofile");
    }
  };

  const handleViewProfile = () => {
    router.push(`/artist/preview/${userData?.id}`);
  };
  const handleSubmitSong = () => {
    router.push("songsubmission");
  };

  return (
    <div>
      <Layout>
        <div className="main-section-artist">
          <div className="artist-baner">
            <div className="art-banner">
              <p>{keyValue.get("title1")}</p>
              {/* <h1>{keyValue.get("title2")}</h1> */}
              <h1 style={{ marginTop: "10px" }}>
                <br /> Generate Song NFTS To Sell <br />
                song royalties to fans
              </h1>
              <p>
                {" "}
                NFTS that bring joy to their fans & collectors online and
                offline
              </p>
              <Box className={classes.btnContainer}>
                {isEmpty(r.token) || !userData?.roles?.includes("artist") ? (
                  <div style={{ marginTop: "30px" }}>
                    <Button
                      onClick={() => handleJoinAsInArtist()}
                      variant="contained"
                      className="btnInfluencer"
                    >
                      Join as an Artist
                    </Button>
                  </div>
                ) : (
                  userData?.roles?.includes("artist") && (
                    <div style={{ marginTop: "30px" }}>
                      <Button
                        onClick={() => handleViewProfile()}
                        variant="contained"
                        className="btnInfluencer"
                      >
                        View Profile
                      </Button>
                    </div>
                  )
                )}
                {userData?.roles?.includes("artist") && (
                  <Button
                    style={{
                      marginTop: "30px",
                      marginLeft: isMobile ? "0px" : "30px",
                    }}
                    onClick={() => handleSubmitSong()}
                    variant="contained"
                    className="btnInfluencer"
                  >
                    Submit your Song
                  </Button>
                )}
              </Box>
            </div>
            <img
              src="./images/artistsubmission/banner-img.png"
              alt="sell-song-Img"
            />
          </div>
          {/* <img
            src="./images/artistsubmission/banner-img.png"
            alt="sell-song-Img"
          /> */}

          {/* <form
            id="artistcontact"
            onSubmit={handleSubmit}
            noValidate
            autoComplete="off"
          >
            <h3>FanTiger for Artist</h3>
            <p>
              Enter your email below to join FanTiger early as an Artist. Our
              team will reach out in time.
            </p>
            <fieldset>
              <input
                placeholder="Name*"
                type="text"
                error={formErrors.username}
                onChange={handleChangeform}
                name="username"
                value={formValues.username}
              />
            </fieldset>
            {formErrors.username && (
              <div
                style={{ color: "red", marginTop: "-15px", textAlign: "left" }}
              >
                {" "}
                {formErrors.username}{" "}
              </div>
            )}
            <fieldset>
              <input
                placeholder="Email Id*"
                type="email"
                error={formErrors.email}
                onChange={handleChangeform}
                name="email"
                value={formValues.email}
              />
            </fieldset>
            {formErrors.email && (
              <div
                style={{ color: "red", marginTop: "-15px", textAlign: "left" }}
              >
                {" "}
                {formErrors.email}{" "}
              </div>
            )}
            <fieldset>
              <input
                placeholder="Mobile Number*"
                error={formErrors.mobile}
                value={formValues.mobile}
                onChange={handleChangeform}
                name="mobile"
                type="tel"
              />
            </fieldset>
            {formErrors.mobile && (
              <div
                style={{ color: "red", marginTop: "-15px", textAlign: "left" }}
              >
                {" "}
                {formErrors.mobile}{" "}
              </div>
            )}
            <fieldset>
              <input
                placeholder="Profile Link (Instagram, Facebook, Twitter, etc)*"
                type="url"
                value={formValues.profileLink}
                onChange={handleChangeform}
                error={formErrors.url}
                name={"profileLink"}
              />
            </fieldset>
            {formErrors.profileLink && (
              <div
                style={{ color: "red", marginTop: "-15px", textAlign: "left" }}
              >
                {" "}
                {formErrors.profileLink}{" "}
              </div>
            )}
            <fieldset>
              <input
                placeholder="Song Link (Youtube / Soundcloud / etc)"
                type="url"
                value={formValues.songLink}
                name={"songLink"}
                onChange={handleChangeform}
              />
            </fieldset>
            {formErrors.songLink && (
              <div style={{ color: "red", textAlign: "left" }}>
                {" "}
                {formErrors.songLink}{" "}
              </div>
            )}
            <p>
              By signing up, you agree to the{" "}
              <span
                style={{ cursor: "pointer", color: "#e14084" }}
                onClick={() => window.open("/terms", "_blank")}
              >
                T&C{" "}
              </span>
              and{" "}
              <span
                style={{ cursor: "pointer", color: "#e14084" }}
                onClick={() => window.open("/privacy", "_blank")}
              >
                Privacy{" "}
              </span>
              and to receive updates from FanTiger.
            </p>
            <fieldset>
              <button
                name="submit"
                type="submit"
                id="artistcontact-submit"
                data-submit="...Sending"
              >
                Submit
              </button>
            </fieldset>
          </form> */}
        </div>
        <section className="sec-section-2">
          <h1 className="sec-section-2-head">{keyValue.get("hiw_title")}</h1>
          <div className="container01">
            <div className="card02-view">
              <div className="card card02">
                <div className="tab-sec">
                  <img
                    src="./images/home/steps/new-icon-1.svg"
                    alt="sell-song-Img"
                  />
                </div>
              </div>
              <div className="card02-disc" style={{ textAlign: "center" }}>
                <h1>{keyValue.get("hiw_title1")}</h1>
                {/* <Typography component="span" className={classes.hiwImageSeparator} /> */}
                <p>{keyValue.get("hiw_desc1")}</p>
              </div>
            </div>
            <div className="card02-view">
              <div className="card card02">
                <div className="tab-sec">
                  <img
                    src="./images/home/steps/new-icon-2.svg"
                    alt="wallet-Img"
                  />
                </div>
              </div>
              <div className="card02-disc" style={{ textAlign: "center" }}>
                <h1>{keyValue.get("hiw_title2")}</h1>
                <p>{keyValue.get("hiw_desc2")}</p>
              </div>
            </div>
            <div className="card02-view">
              <div className="card card02">
                <div className="tab-sec">
                  <img
                    src="./images/home/steps/new-icon-3.svg"
                    alt="sell-song-Img"
                  />
                </div>
              </div>
              <div className="card02-disc" style={{ textAlign: "center" }}>
                <h1>{keyValue.get("hiw_title3")}</h1>
                <p>{keyValue.get("hiw_desc3")}</p>
              </div>
            </div>
          </div>

          <h1 className="sec-section-2-head">Mint NFTs to Sell</h1>
          <div className="container02">
            <Typography component="p" className={classes.subTitle}>
              Turn Your Songs into easy to collect NFTs for fans/ collectors.
              Each song gets converted into 3-4 different NFT tiers. Each NFT
              tier has a specific royalty share percentage and privileges
              granted against it
            </Typography>
            <img
              src="./images/artistsubmission/mint-nft.png"
              className="mint-nft"
              alt="mint-nft"
            />
            <img
              src="./images/artistsubmission/backdrop-shadow.png"
              className="mint-shadow"
              alt="song-nft"
            />
          </div>

          <h1 className="sec-section-2-head">Artists</h1>
          <div className="container02">
            {/* <Typography component="p" className={classes.subTitle}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua
          </Typography> */}
            <Box className={classes.artistSliderBox}>
              <Slider {...artistsettings}>
                <div>
                  <Box
                    className={classes.artistBox}
                    onClick={() => router.push("/artist/sunanda-sharma")}
                  >
                    <Box
                      component="img"
                      src="/images/artistsubmission/sunanda.png"
                    />
                    <Box
                      component="img"
                      src="/images/artistsubmission/sunanda.png"
                    />
                  </Box>
                  <Typography component="p">Sunanda</Typography>
                </div>
                <div>
                  <Box
                    className={classes.artistBox}
                    onClick={() => router.push("/artist/naalayak")}
                  >
                    <Box
                      component="img"
                      src="/images/artistsubmission/nusrat.png"
                    />
                    <Box
                      component="img"
                      src="/images/artistsubmission/nusrat.png"
                    />
                  </Box>
                  <Typography component="p">Nalayak</Typography>
                </div>
                <div>
                  <Box className={classes.artistBox}>
                    <Box
                      component="img"
                      src="/images/artistsubmission/harvi.png"
                    />
                    <Box
                      component="img"
                      src="/images/artistsubmission/harvi.png"
                    />
                  </Box>
                  <Typography component="p">Harvi</Typography>
                </div>
                <div>
                  <Box
                    className={classes.artistBox}
                    onClick={() => router.push("/artist/saaj-bhatt")}
                  >
                    <Box
                      component="img"
                      src="/images/artistsubmission/shubh.png"
                    />
                    <Box
                      component="img"
                      src="/images/artistsubmission/shubh.png"
                    />
                  </Box>
                  <Typography component="p">Saaj</Typography>
                </div>
              </Slider>
            </Box>
          </div>

          <div className="faq-sec">
            <h1 className="sec-section-2-head">FAQ&#39;s</h1>
            <div className="accordion-wrapper">
              {artistQuestion.data &&
                artistQuestion?.data?.map((item) => {
                  return (
                    <div
                      className={
                        expanded === item.id + 1
                          ? "accordion show"
                          : "accordion"
                      }
                      key={item.id}
                    >
                      <div
                        className="accordion-label"
                        onClick={() => handlePanel(item.id + 1)}
                      >
                        {item?.attributes.question}
                      </div>
                      <div className="accordion-content">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                          {item?.attributes.answer}
                        </ReactMarkdown>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <Modal
            open={successModal}
            onClose={() => {
              setSuccessModal(false);
            }}
          >
            <>
              <Box className={classes.root}>
                <Box className={classes.alertMessage}>
                  <Box
                    component="img"
                    src="/images/alert/success-icon.svg"
                    width="20px"
                  />
                  <Typography variant="span" className={classes.content}>
                    Your application is submitted successfully
                  </Typography>
                </Box>

                <Box
                  onClick={() => {
                    setSuccessModal(false);
                  }}
                  component="img"
                  src="/images/alert/close-icon.svg"
                  style={{ cursor: "pointer" }}
                  width="20"
                />
              </Box>
              {/* <div className="successModal_influencer">
              Your application is submitted successfully
            </div>
            <div
              style={{
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                top: "205px",
                left: "1290px",
                cursor: "pointer",
              }}
              onClick={() => {
                setSuccessModal(false);
              }}
            >
              <MdOutlineClose size={24} color="#000000" />
            </div> */}
            </>
          </Modal>
        </section>
        <br></br>
        <br></br>
        <br></br>
        <br></br>

        <Footer />
      </Layout>
    </div>
  );
}
